import Spektrix from './classes/Spektrix'
import alert from './alert'

jQuery(document).ready(($) => {
  const client = new Spektrix()

  const logCustomerIn = (customer) => {
    const now = new Date()
    now.setTime(now.getTime() + (30 * 60 * 1000))
    document.cookie = 'customer=true; expires=' + now.toUTCString() + ';'
    window.location = '/season/' + now.getFullYear()
    return true
  }

  const customerIsValid = (customerTags) => {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: appURL + '/ajax/validate-customer-tags',
        method: 'post',
        dataType: 'json',
        data: {
          'customer_tags': customerTags
        },
        success: function (response) {
          resolve(response.ok === true)
        },
        error: function (error) {
          reject(error)
        }
      })
    })
  }

  const customerTags = ((spektrix) => {
    return (successCallback) => {
      spektrix.get('customer/tags')
        .then((response) => {
          if (response.ok) {
            return response.json()
          }
        })
        .then((tags) => {
          successCallback(tags)
        })
    }
  })(client)

  const authenticateUser = ((spektrix) => {
    return (username, password, successCallback) => {
      spektrix.post('customer/authenticate', {
        body: {
          email: username,
          password: password
        }
      })
        .then((response) => {
          if (response.ok) {
            successCallback(response.json())
          } else {
            alert.formError('Please check your credentials and try again')
          }
        })
    }
  })(client)

  $('#login').on('click', (event) => {
    event.preventDefault()

    $('#errors').find('.basket-flash-message').remove()

    authenticateUser(
      $('input[name="email"]').val(),
      $('input[name="password"]').val(),
      (customer) => {
        customerTags((tags) => {
          customerIsValid(tags)
            .then((isValid) => {
              if (isValid) {
                logCustomerIn(customer)
              } else {
                alert.formError('Sorry you are not eligible to use our package builder.')
              }
            })
            .catch((error) => {
              console.error('Error checking customer validity:', error)
              alert.formError(`
                An error occurred. Please try again later.<br>
                If this issue persists, you may have to <a href="https://system.spektrix.com/emelin/website/Cookies.aspx" target="_blank">update your browser's cookies settings</a>.
              `, true)
            })
        })
      }
    )
  })

  $('.c-page-content-membership .c-btn').on('click', function () {
    setInterval(function () {
      window.BASKET.refresh()
      logCustomerIn()
    }, 3000) // Lets assume that this an arbitrary amount of time.
  })
})



// WEBPACK FOOTER //
// ./resources/assets/js/auth.js